<div class="bonusDialog">
  <h2
    mat-dialog-title>{{ bonus.name }}{{ (showBonusPoints) ? ' - ' + bonus.bonusValue + ' ' + translationService.getTranslation('order_bonusPoints') : '' }}</h2>
  <mat-dialog-content class="mat-typography">
    <img *ngIf="bonus.image" [alt]="bonus.image.altText"
         [src]="bonus.image.srcUrl" class="bonusImg" fitImage>
    <p [innerHTML]="bonus.description"></p>

    <p *ngIf="bonus.userAdjustment > 0" [innerHTML]="translationService.getTranslation('order_adjustment') + ' ' + bonus.userAdjustment + ' ' + bonus.isoCurrencyCode">
      <br/>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary" mat-dialog-close=""
            [innerHTML]="translationService.getTranslation('button_close')"></button>
  </mat-dialog-actions>
</div>
